import React from 'react';
import './SideNav.css';

import {
  AiFillHome as AiFillHomeRaw,
  AiOutlineHome as AiOutlineHomeRaw,
  AiOutlineBell as AiOutlineBellRaw,
  AiFillBell as AiFillBellRaw,
} from 'react-icons/ai';
import { MdOutlineExplore as MdOutlineExploreRaw, MdExplore as MdExploreRaw } from 'react-icons/md';
import { IoLocationOutline as IoLocationOutlineRaw, IoLocationSharp as IoLocationSharpRaw } from 'react-icons/io5';
import { RiMovieLine as RiMovieLineRaw, RiMovieFill as RiMovieFillRaw } from 'react-icons/ri';
import { FiSend as FiSendRaw } from 'react-icons/fi';
import { CgAddR as CgAddRRaw, CgMoreO as CgMoreORaw } from 'react-icons/cg';
import { OzellikIkonu } from "./icon-system/runtime/OzellikIkonu";

const AiFillHome = AiFillHomeRaw as any;
const AiOutlineHome = AiOutlineHomeRaw as any;
// ÜRÜN KURALI: kalp YOK → bildirim ikonu çan (bell).
const AiOutlineBell = AiOutlineBellRaw as any;
const AiFillBell = AiFillBellRaw as any;
const MdOutlineExplore = MdOutlineExploreRaw as any;
const MdExplore = MdExploreRaw as any;
const IoLocationOutline = IoLocationOutlineRaw as any;
const IoLocationSharp = IoLocationSharpRaw as any;
const RiMovieLine = RiMovieLineRaw as any;
const RiMovieFill = RiMovieFillRaw as any;
const FiSend = FiSendRaw as any;
const CgAddR = CgAddRRaw as any;
const CgMoreO = CgMoreORaw as any;

const PUBLIC_URL = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const APP_LOGO_URL = `${PUBLIC_URL}/logo192.png`;

// FAZ C / DALGA 1 — İKON KÖPRÜSÜ: bayrak (`mylasa.ff.ikon`) kapalıyken `eski`
// (react-icons / emoji, piksel-birebir), açıkken motor (`generated/*`) çizilir.
// Aktif sekme = `varyant="selected"`, diğerleri outline (MYLASA_ICON_SYSTEM §1).
//
// ══════════════════════════════════════════════════════════════════════════
// ÖZELLİK KAYDI (2026-09-20) — masaüstü de AYNI defterden okuyor
// ══════════════════════════════════════════════════════════════════════════
// Eskiden burada doğrudan 10 `IkonKoprusu` vardı: aile adı, hangi varyantın
// "aktif" olduğu ve erişilebilir ad HER SATIRDA ayrı ayrı yazılıydı; kayıt
// defteri yalnız `BottomNav`a bağlıydı. Ölçülen sonuç: masaüstü yüzeyinde
// hiçbir düğüm `data-ozellik` taşımıyordu → uçtan uca hareket ekseni (GÖZ)
// düğümü bulamayıp "ÖLÇEMEDİM" dönüyordu. Zincir masaüstünde KORUNMUYORDU.
//
// Artık tek yol var: `ozellikKaydi.URUN_OZELLIKLERI` → `OzellikIkonu` →
// `IkonKoprusu`. İkinci bir ikon sistemi YOK; `eski` kolu (react-icons /
// emoji + `rotate(20deg)` / drop-shadow süsleri) BİREBİR duruyor, yani
// bayrak kapalıyken piksel deltası sıfırdır.
type YanBaglanti = {
    id: string;
    text: string;
    /**
     * Satırın ikonu. Fabrika olmasının İKİ ölçülmüş sebebi var:
     *  1. `eski` düğümü (react-icons) `OzellikIkonu`nun `eski={…}` prop'unun
     *     İÇİNDE, LEKSİK olarak durmalı. Onları dizi alanına taşıyan ilk
     *     yazımda geçiş planı (`ikon:gecis`) 14 satırı "hazır" (= henüz
     *     taşınmamış) saydı — oysa taşınmışlardı; alet gelecekteki bir ajana
     *     zaten yapılmış işi yaptırırdı.
     *  2. Aktif/pasif kolda AYNI eleman tipi döner → React güncelleme yapar,
     *     yeniden MOUNT ETMEZ; `IconFrame`in ilk-açılış/durum-değişimi ayrımı
     *     düğümün kendi geçmişine dayandığı için bu şarttır.
     */
    ikon?: (aktif: boolean) => React.ReactElement;
    profile?: boolean;
};

function SideNav({ activeTab, onTabChange, profilePic }: any) {

    const navLinks: YanBaglanti[] = [
        { id: 'home', text: 'Ana Sayfa', ikon: (aktif) => <OzellikIkonu ozellik="nav.home" secili={aktif} eski={aktif ? <AiFillHome /> : <AiOutlineHome />} /> },
        { id: 'explore', text: 'Keşfet', ikon: (aktif) => <OzellikIkonu ozellik="nav.explore" secili={aktif} eski={aktif ? <MdExplore /> : <MdOutlineExplore />} /> },
        { id: 'map', text: 'Konumlar', ikon: (aktif) => <OzellikIkonu ozellik="nav.map" secili={aktif} eski={aktif ? <IoLocationSharp /> : <IoLocationOutline />} /> },
        { id: 'clips', text: 'MyClips', ikon: (aktif) => <OzellikIkonu ozellik="nav.clips" secili={aktif} eski={aktif ? <RiMovieFill /> : <RiMovieLine />} /> },
        { id: 'messages', text: 'Mesajlar', ikon: (aktif) => <OzellikIkonu ozellik="nav.messages" secili={aktif} eski={aktif ? <FiSend style={{ transform: 'rotate(20deg)' }} /> : <FiSend />} /> },
        { id: 'notifications', text: 'Bildirimler', ikon: (aktif) => <OzellikIkonu ozellik="nav.notifications" secili={aktif} eski={aktif ? <AiFillBell /> : <AiOutlineBell />} /> },
        { id: 'createMenu', text: 'Oluştur', ikon: (aktif) => <OzellikIkonu ozellik="nav.create" secili={aktif} eski={<CgAddR />} /> },
        // EMİR #76 — İlk Işıklar keşif galerisi (/discoveries; tam sayfa).
        {
            id: 'discoveries', text: 'İlk Işıklar',
            ikon: (aktif) => (
                <span style={{ fontSize: 19, filter: aktif ? 'drop-shadow(0 0 4px rgba(217,164,65,0.8))' : undefined }}>
                    <OzellikIkonu ozellik="nav.discoveries" secili={aktif} eski="🌟" />
                </span>
            ),
        },
        // ─── DISCOVERY: Sosyal Keşif ─── Mevcut hiçbir şeye dokunmaz
        {
            id: 'discovery', text: 'Sosyal Keşif',
            ikon: (aktif) => (
                <span style={{ fontSize: 20, filter: aktif ? 'drop-shadow(0 0 4px rgba(118,75,162,0.7))' : undefined }}>
                    <OzellikIkonu ozellik="nav.discovery" secili={aktif} eski="✨" />
                </span>
            ),
        },
        { id: 'profile', text: 'Profil', profile: true },
    ];

    /** Bir satırın ikonu — kayıt defterinden (tek yol). */
    const satirIkonu = (link: YanBaglanti): React.ReactNode =>
        link.ikon ? link.ikon(activeTab === link.id) : null;

    return (
        <nav className="sidenav-container">
            <div className="sidenav-logo-container" onClick={() => window.location.reload()}>
                <img src={APP_LOGO_URL} alt="Mylasa İkon" className="sidenav-logo-icon" />
                <span className="sidenav-logo-text">mylasa</span>
            </div>

            <ul className="sidenav-links">
                {navLinks.map(link => (
                    <li key={link.id}>
                        <a onClick={() => onTabChange(link.id)} className={`sidenav-link ${activeTab === link.id ? 'active' : ''}`}>
                            <span className="sidenav-icon">
                                {link.profile ? (
                                    profilePic
                                        ? <img src={profilePic} alt="Profil" className="sidenav-profile-pic" />
                                        : <div className="sidenav-profile-pic" style={{ background: '#e0e0e0' }}></div>
                                ) : (
                                    satirIkonu(link)
                                )}
                            </span>
                            <span className="sidenav-text">{link.text}</span>
                        </a>
                    </li>
                ))}
            </ul>

            <div className="sidenav-more">
                <a className="sidenav-link">
                    <span className="sidenav-icon"><OzellikIkonu ozellik="nav.more" eski={<CgMoreO />} /></span>
                    <span className="sidenav-text">Daha fazla</span>
                </a>
            </div>
        </nav>
    );
}

export default SideNav;
